// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__26OH3","title":"Header_title__2hLcH","side":"Header_side__f2m1R"};